import React from 'react';

import Tippy from '@tippyjs/react';

import { iaRa } from 'lib/helpers/utility';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

const TableTippy = ({ value }) => {
  const maxLength = 1;
  const items = iaRa(value);
  const remainingValues = items.slice(maxLength);
  const firstLabel = items[0]?.label;
  return (
    <>
      {remainingValues.length > 0 ? (
        <Tippy
          arrow={true}
          placement="left-start"
          className="tippy-dark"
          content={items.map((item, idx) => (
            <p key={idx} className="relative px-1 text-[12px] font-500 text-white">
              {item?.label}
            </p>
          ))}>
          <p>{firstLabel?.slice(0, 8)}...</p>
        </Tippy>
      ) : (
        <p>{firstLabel || '-'}</p>
      )}
    </>
  );
};

export default withErrorBoundary(TableTippy);
